import {Component, ViewChild} from '@angular/core';
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {CheckService} from "../../../../@shared/services/check.service";
import {ActivatedRoute} from "@angular/router";
import {switchMap, tap} from "rxjs/operators";

export interface ICheckWallet {
  id: number;
  date: string;
  name: string;
  is_locked: boolean;
  points: number;
}

@Component({
  selector: 'app-check-wallet',
  templateUrl: './check-wallet.component.html',
  styleUrls: ['./check-wallet.component.scss']
})
export class CheckWalletComponent {

  @ViewChild(MatPaginator, {static: false}) paginator!: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort!: MatSort;

  checkWalletColumns: string[] = ['id', 'date', 'name', 'is_locked', 'points'];
  checkWallet: MatTableDataSource<ICheckWallet> = new MatTableDataSource<ICheckWallet>();

  public wallet: string | null = null;
  public isLoading: boolean = true;

  constructor(private activatedRoute: ActivatedRoute,
              private checkService: CheckService) {
    this.activatedRoute.paramMap.pipe(
      tap(() => {
        this.isLoading = true;
        this.checkWallet = new MatTableDataSource<ICheckWallet>();
      }),
      switchMap(params => {
        this.wallet = params.get('wallet');
        return this.checkService.findByWallet(this.wallet);
      }),
    ).subscribe(data => {
      this.isLoading = false;
      this.checkWallet = new MatTableDataSource(data);
      this.checkWallet.paginator = this.paginator;
      this.checkWallet.sort = this.sort;
    }, error => this.isLoading = false);
  }

  public blockAllUsersByWallet(): any {
    console.log('Блок блок блок!1: ', this.wallet);
  }

}
